import { render, staticRenderFns } from "./AroundCard.vue?vue&type=template&id=ef44245e&"
import script from "./AroundCard.vue?vue&type=script&lang=js&"
export * from "./AroundCard.vue?vue&type=script&lang=js&"
import style0 from "./AroundCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports